import { Card, Form } from 'antd';
import { PageHeader } from '@ant-design/pro-components';
import Partform from 'components/Partform/Partform';
import { RouteConfigs } from 'config/routes';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { rootContext } from 'stores';
import {
  IfileUploadHookReturn,
  useFileUploadHook
} from 'hooks/FileUpload.hook';
import './Editpart.scss';
import { allowedType, allowedTypePart, toast, toastTypeEnum } from 'common/utils';
import { IcreatePartFormValues, IRegion } from 'types';
import dayjs from 'dayjs';
import { ISubModelInputs } from 'pages/Createpart/Createpart';
import { observer } from 'mobx-react';

const Editpart: React.FC = observer(() => {
  const {
    PartsStore: {
      state: {
        data: { editPart },
        ui
      },
      updatePart
    }
  } = useContext(rootContext);

  const navigate = useNavigate();

  const [editPartForm] = Form.useForm();
  const [autoIncrement, setAutoIncrement] = useState(
    editPart?.autoEndYearIncrement || false
  );
  useEffect(() => {
    if (!editPart) {
      navigate(RouteConfigs.index.path);
    } else {
      const {
        file,
        url,
        startMakingYear,
        endMakingYear,
        ...editData
      } = editPart;

      editPartForm.setFieldsValue({
        ...editData,
        makingYear: [
          dayjs(editPart.startMakingYear),
          dayjs(editPart.endMakingYear)
        ],
        name: editPart.name,
        region: editPart.region.map((item: IRegion) => item.id),
        brand: editData.brand_id
      });
    }
  }, [editPart, editPartForm, navigate]);

  const partSvgFileUploadHook: IfileUploadHookReturn = useFileUploadHook(
    allowedTypePart
  );

  const carModelFileUploadHook: IfileUploadHookReturn = useFileUploadHook(
    allowedType
  );
  const [subModelInputs, setSubModelInputs] = useState<ISubModelInputs[]>([]);

  const [svgFile, setSvgFile] = useState<Blob>();
  const saveFileContent = (fileContent: string) => {
    let blob = new Blob([fileContent], { type: 'image/svg+xml' });
    var file = new File([blob], 'image.svg');
    setSvgFile(file);
  };

  const onSubmit = async (values: IcreatePartFormValues): Promise<void> => {
    values.startMakingYear = dayjs(values.makingYear[0]).format('YYYY');
    values.endMakingYear = !autoIncrement
      ? (dayjs(values.makingYear[1]).format('YYYY') as string) : null;
    delete values.makingYear;
    if (!editPart) {
      return;
    }
    const data = await updatePart({
      ...values,
      id: editPart.id,
      file: svgFile,
      model_image: carModelFileUploadHook.fileList[0],
      autoIncrementEndYear: autoIncrement,
      over_write: true
    });
    if (data === true) {
      editPartForm.resetFields();
      navigate(RouteConfigs.index.path);
      toast(toastTypeEnum.success, "Part updated.");
      partSvgFileUploadHook.onRemove();
      carModelFileUploadHook.onRemove();
    }
  };

  return (
    <div className="EditpartStyles CreatepartStyles">
      <div className="cardWrapeer">
        <Card>
          <PageHeader title="Edit Part" onBack={() => navigate(-1)} />
          <div className="PartForm">
            <Partform
              autoIncrement={autoIncrement}
              setAutoIncrement={setAutoIncrement}
              form={editPartForm}
              regionIds={editPart?.region.map((item: IRegion) => item.id)}
              partSvgFileUploadHook={partSvgFileUploadHook}
              carModelFileUploadHook={carModelFileUploadHook}
              onSubmit={onSubmit}
              saveFileContent={saveFileContent}
              loading={ui.editPartsLoading}
              mode="edit"
              subModelInputs={subModelInputs}
              setSubModelInputs={setSubModelInputs}
            />
          </div>
        </Card>
      </div>
    </div>
  );
});

export default Editpart;
